import { getPayoutLink } from '@api/payout';
import claimtip from '@assets/images/payout_page/Money.svg';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import StripeInfoCollect from './StripeCollectInfo';

export function getPaymentProcessorsForCountry(country, payoutlink) {
  // `profile.country` is written by five different paths with three different
  // conventions — signup stores it as sent, the Multitool uppercases, the RPC
  // and TipDirectAPI lowercase — so this has to fold case or a Canadian guide
  // stored as `CA` falls past the US branch, past the EU branch, and out of the
  // bottom with an empty list: a payout page with no way to get paid.
  const countryCode = (country || '').toLowerCase();

  if (process.env.REGION === 'QA') {
    return [
      {
        name: 'Revolut',
        icon: require('../../assets/images/payout_page/Revolut.svg'),
        link: payoutlink ?? ''
      },
      {
        name: 'Bank Transfer',
        icon: require('../../assets/images/payout_page/Transfer.svg'),
        link: payoutlink ?? ''
      }
    ];
  }

  if (process.env.REGION === 'US' && countryCode === 'ca') {
    return [
      {
        name: 'Bank Transfer',
        icon: require('../../assets/images/payout_page/Transfer.svg'),
        link: payoutlink ?? ''
      }
    ];
  }

  if (process.env.REGION === 'EU') {
    return [
      {
        name: 'Revolut',
        icon: require('../../assets/images/payout_page/Revolut.svg'),
        link: payoutlink ?? ''
      },
      {
        name: 'Visa Debit Card',
        icon: require('../../assets/images/payout_page/Visa.svg'),
        link: payoutlink ?? ''
      },
      {
        name: 'MasterCard Debit Card',
        icon: require('../../assets/images/payout_page/Mastercard.svg'),
        link: payoutlink ?? ''
      },
      {
        name: 'Bank Transfer',
        icon: require('../../assets/images/payout_page/Transfer.svg'),
        link: payoutlink ?? ''
      }
    ];
  }

  return [];
}

const primaryButtonClasses =
  'bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-5 py-2.5 rounded-xl shadow-sm transition-colors cursor-pointer border-0 disabled:opacity-50 disabled:cursor-not-allowed';

const PayoutLink = ({ user }) => {
  useEffect(() => {
    getPayoutLinkInfo();
  }, []);

  let [payoutLink, setPayoutLink] = useState(null);
  let [errorMessage, setErrorMessage] = useState(null);
  let [showStripeCollectInfo, setShowStripeCollectInfo] = useState(false);
  let [payoutLinks, setPayoutLinks] = useState(
    getPaymentProcessorsForCountry(user.profile.country)
  );

  async function getPayoutLinkInfo() {
    let payoutLinkResp = await getPayoutLink();
    if (payoutLinkResp) {
      setPayoutLink(payoutLinkResp);
      setPayoutLinks(
        getPaymentProcessorsForCountry(user.profile.country, payoutLinkResp.payoutLinkBody.url)
      );
    } else {
      setErrorMessage(
        'A valid payout could not be retrieved for this user. Please ensure that you are signed in as the user that received the tip.'
      );
    }
  }

  function renderPayoutLinkButton(payoutLink) {
    return (
      <button
        type="button"
        className={primaryButtonClasses}
        onClick={() => (window.location = payoutLink.link)}>
        Select
      </button>
    );
  }

  function renderLinkBox(payoutLink) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-solid border-slate-200 p-3 mb-4 flex flex-row justify-between items-center">
        <div className="flex items-center">
          <div className="w-9 h-9 rounded-full bg-white shadow-sm border border-solid border-slate-200 flex items-center justify-center overflow-hidden mr-3 shrink-0">
            <img src={payoutLink.icon} alt="" className="w-9 h-9" />
          </div>
          <div className="text-sm font-bold text-slate-800 tracking-wide">{payoutLink.name}</div>
        </div>
        <div className="text-right">{renderPayoutLinkButton(payoutLink)}</div>
      </div>
    );
  }
  // if (!payoutLink) {
  //   if (errorMessage) {
  //     return (
  //       <div className={classes.container}>
  //         <div className={classes.innerContainer}>
  //           <Paper className={classes.outerSurface} elevation={0}>
  //             <Paper
  //               className={classes.innerSurface}
  //               elevation={3}
  //               style={{ display: 'flex', fontSize: 13 }}>
  //               <Paper className={classes.iconContainer} elevation={3}>
  //                 <img src={warningicon} style={{ width: '20px', margin: 'auto' }} />
  //               </Paper>
  //               <div>
  //                 <span className={classes.boldHeading}>We're sorry!</span> - {errorMessage}
  //               </div>
  //             </Paper>
  //           </Paper>
  //           <Button
  //             variant="contained"
  //             color="primary"
  //             onClick={() => {
  //               window.location = '/tipdirect';
  //             }}>
  //             Back to TipDirect
  //           </Button>
  //         </div>
  //       </div>
  //     );
  //   }
  //   return (
  //     <div style={{ margin: 'auto', marginTop: '50px', width: '40px' }}>
  //       <CircularProgress />
  //     </div>
  //   );
  // }

  //Using Stripe by default
  return <StripeInfoCollect user={user} />

  return (
    <div className="w-full px-4 py-10">
      <div className="flex flex-col max-w-md mx-auto">
        <div className="bg-slate-50 rounded-3xl shadow-sm border border-solid border-slate-200 p-6 mb-6">
          <div className="bg-white rounded-2xl shadow-sm border border-solid border-slate-200 p-4 flex text-[13px] text-slate-600">
            <div className="w-9 h-9 rounded-full bg-white shadow-sm border border-solid border-slate-200 flex items-center justify-center overflow-hidden mr-3 shrink-0">
              <img src={claimtip} />
            </div>
            <div>
              <span className="font-semibold text-slate-800">Your tip is ready to be claimed!</span> - Choose
              one of our payout options below. All future payouts will be made using the payout
              method you select.
            </div>
          </div>
        </div>

        <div className="bg-slate-50 rounded-3xl shadow-sm border border-solid border-slate-200 p-6 mb-6">
          {payoutLinks.map(renderLinkBox)}
        </div>
      </div>
      <div className="text-center font-semibold text-xs text-slate-500 tracking-wide max-w-[240px] mx-auto mt-6">
        TipDirect payouts are made via secure end-to-end encryption.
        <br />
        <img
          className="mt-1 inline-block"
          src={require('../../assets/images/payout_page/Encryption.svg')}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.user?.user
});

export default connect(mapStateToProps)(PayoutLink);
